import { ruleDefinitionDefaults, defaultValidationTagRule, createValidator, createClashingRulesValidationFunctionNew } from './TagRulesCommon'

const ruleDefinition =
{
    ...ruleDefinitionDefaults,
    ruleType: "UpdateProductMetafieldFromTagMapping",
    title: "Update Product Metafield From Tag Using Mapping Table",
    description: "Automatically set product metafield value based on a product tag by providing a mapping table to map tag to metafield value.",
    example: "Use this rule to map specific tags like 'material-cotton' to a metafield value like 'Cotton'.",
    additional: [],
    legacy: false,
    inProgress: false,
    previewType: "ProductMetafields",
    dataPermissions: ["products"],
    allowPreview: false,
    tags: ["Products", "Metafields"],
    getDefaultRuleState: () => {
        return {
            name: null,
            trigger: "Automatic",
            settings: {
                ruleTypeId: "UpdateProductMetafieldFromTagMapping",
                metafieldNamespaceAndKey: null,
                metafieldType: "single_line_text_field",
                removeMetafieldValueWhenTagIsMissing: false,
                valueMappings: []
            }
        }
    },
    createValidator: (onAsyncError) => {
        return createValidator(
            onAsyncError,
            [defaultValidationTagRule,
                (rule, errors) => {

                    if (rule.settings.metafieldNamespaceAndKey == null || !/^(.+\..+)$/.test(rule.settings.metafieldNamespaceAndKey)) {
                        errors["metafieldNamespaceAndKey"] = "Incorrect metafield namespace and key";
                    }

                    if (rule.settings.metafieldType == null || rule.settings.metafieldType === "") {
                        errors["metafieldType"] = "Metafield type is required";
                    }
                }
            ], createClashingRulesValidationFunctionNew("PRODUCT"));
    }
};

export default ruleDefinition;
